/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespTradeFreeShippingPromoTile_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedPriceTile_itemSearch">;
    readonly " $refType": "SbRespTradeFreeShippingPromoTile_itemSearch";
};
export type SbRespTradeFreeShippingPromoTile_itemSearch$data = SbRespTradeFreeShippingPromoTile_itemSearch;
export type SbRespTradeFreeShippingPromoTile_itemSearch$key = {
    readonly " $data"?: SbRespTradeFreeShippingPromoTile_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespTradeFreeShippingPromoTile_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespTradeFreeShippingPromoTile_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPriceTile_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'b18c6827312034d7f6d6894289270497';
export default node;
